import React from 'react';
import {
  ZfAccordion,
  ZfBox,
  ZfDrawerHeader,
  ZfDrawerFooter,
  ZfStack,
  ZfTextButton,
  ZfTypography,
  ZfAccordionItem,
} from '@zafire/react';
import { useDispatch } from 'react-redux';
import { PortfolioTableItemDetails } from './PortfolioTableItem';
import { StatusPill } from 'views/PrivateBanking/StatusPill';
import { DetailsSection } from './PortfolioSections/DetailsSection';
import { AdditionalDetailsSection } from './PortfolioSections/AdditionalDetailsSection';
import { clearSelectedPortfolio } from '../../reducers/portfolioReducer';
import { RevisionHistory } from './PortfolioSections/RevisionHistory';

type PortfolioDetailsProps = {
  portfolio: PortfolioTableItemDetails;
};

const PortfolioDetails: React.FC<PortfolioDetailsProps> = ({ portfolio }) => {
  const dispatch = useDispatch();
  const onClose = () => dispatch(clearSelectedPortfolio());
  // const blocks = getProductDetailsBlocks(product);

  return (
    <ZfBox style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <ZfDrawerHeader onClick={onClose}>Portfolio Details</ZfDrawerHeader>

      <ZfStack
        id="private-banking-details-container"
        spacing="medium"
        style={{
          padding: '16px',
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          overflowY: 'auto',
        }}
      >
        <ZfStack direction="row" spacing="small">
          <ZfTypography variant="body-large">{portfolio.portfolioNumber ?? '-'}</ZfTypography>
          <StatusPill status={portfolio.portfolioStatus} clickable={false} />
        </ZfStack>

        <ZfAccordion type="multiple">
          <ZfAccordionItem state="active" titleText="Details">
            <DetailsSection portfolio={portfolio} />
          </ZfAccordionItem>
          <ZfAccordionItem titleText="Additional details">
            <AdditionalDetailsSection portfolio={portfolio} />
          </ZfAccordionItem>
          <ZfAccordionItem state="active" titleText="Portfolio revision history">
            <RevisionHistory portfolio={portfolio} />
          </ZfAccordionItem>
        </ZfAccordion>
      </ZfStack>

      <ZfDrawerFooter>
        <ZfTextButton slot="primary" hierarchy="tertiary" size="small" onClick={onClose}>
          Cancel
        </ZfTextButton>
      </ZfDrawerFooter>
    </ZfBox>
  );
};

export default PortfolioDetails;
